{
  "more": "Altri elementi"
}
